import React, { useEffect, useState } from "react";
import { LuHourglass } from "react-icons/lu";
import { useNavigate, useParams } from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import { MdKeyboardArrowDown } from "react-icons/md";
import { CiSearch } from "react-icons/ci";

const Orders = () => {
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState([]);
  const [active, setActive] = useState("All");
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState({ id: "", name: "Status" });
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const statusList = [
    { _id: 1, name: "completed" },
    { _id: 2, name: "confirmed" },
    { _id: 3, name: "on Delivery" },
    { _id: 4, name: "delivered" },
    { _id: 5, name: "denied" },
  ];
  const limit = 20;

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchQuery(search);
      setPage(1);
    }, 400);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const res = await apiRequests.get("/invoice/get-all-seller", {
          params: { page, limit, search: searchQuery },
        });
        setProducts(res.data.data.docs || []);
        setTotalPage(res.data.data.totalPage || 1);
        setPage(res.data.data.page || 1);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [page, searchQuery]);

  const getStatusStyle = (status = "") => {
    const lowerStatus = status.toLowerCase();

    switch (lowerStatus) {
      case "confirmed":
        return "bg-[#ADD3F2] text-[#0A3C63]";
      case "on delivery":
        return "bg-[#FFE9A6] text-[#634C05]";
      case "delivered":
        return "bg-[#BBDCBC] text-[#204422]";
      case "denied":
        return "bg-[#F3B8B4] text-[#69120B]";
      case "pending":
        return "bg-[#FFE9A6] text-[#634C05]";
      default:
        return "bg-gray-200 text-gray-700";
    }
  };
  const navigate = useNavigate();
  const filteredProducts = (() => {
    let result = products;

    if (active === "New") {
      const today = new Date();
      result = result.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return (
          itemDate.getFullYear() === today.getFullYear() &&
          itemDate.getMonth() === today.getMonth() &&
          itemDate.getDate() === today.getDate()
        );
      });
    }

    if (status.name && status.name !== "Status") {
      result = result.filter((item) => item.status === status.name);
    }

    return result;
  })();

  return (
    <div className="w-full px-10 flex gap-3 flex-col py-8 font-inter">
      <div className="flex flex-row">
        <div className="flex items-center gap-2">
          <h1 className="text-2xl font-semibold ">Orders</h1>
          {/* button */}

          <button
            onClick={() => setActive("All")}
            className={`border rounded-xl px-6 py-2 font-medium transition-colors
    ${
      active === "All"
        ? "bg-[#BCB6B3] text-black border-[#BCB6B3]"
        : "border-[#5C5957] text-[#5C5957] hover:bg-[#BCB6B3]"
    }`}
          >
            All
          </button>

          <button
            onClick={() => setActive("New")}
            className={`border rounded-xl px-10 py-2 font-medium transition-colors
    ${
      active === "New"
        ? "bg-[#BCB6B3] text-black border-[#BCB6B3]"
        : "border-[#5C5957] text-[#5C5957] hover:bg-[#BCB6B3]"
    }`}
          >
            New
          </button>
        </div>
        {/* status */}
        <div className="relative flex items-center ml-auto">
          <div className="relative w-75 px-2">
            <CiSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name..."
              className="w-full h-11 pl-11 pr-4 rounded-xl border border-gray-200
                             bg-white text-sm text-gray-700 outline-none
                             focus:border-[#024E88]"
            />
          </div>
          <button
            onClick={() => setOpen((prev) => !prev)}
            className="w-40 z-20 bg-white border border-neutral-600 text-neutral-600 rounded-xl px-4 py-2  flex justify-between items-center"
          >
            {status.name || "Status"}

            <MdKeyboardArrowDown className="ml-2 h-5" />
          </button>

          {open && (
            <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-2xl shadow-lg z-30 ">
              {statusList.map((option, i) => (
                <li
                  key={i}
                  onClick={() => {
                    setStatus(option);
                    setOpen(false);
                  }}
                  className={` py-2 cursor-pointer text-neutral-700 hover:bg-gray-100
           border-b border-gray-200 last:border-b-0 mx-4 ${option.name}`}
                >
                  {option.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <table className="w-full text-left overflow-x-auto">
        <thead className="">
          <tr className="bg-gradient-to-r from-[#051F33] to-[#024E88] text-white">
            <th className="p-4 font-medium capitalize rounded-tl-2xl">
              customer name
            </th>
            <th className="p-4 font-medium capitalize">order id</th>
            <th className="p-4 font-medium capitalize text-center">
              product amount
            </th>
            <th className="p-4 font-medium capitalize">paid amount</th>
            <th className="p-4 font-medium capitalize text-center">status</th>
            <th className="p-4 font-medium capitalize text-center rounded-tr-2xl">
              action
            </th>
          </tr>
        </thead>

        <tbody>
          {filteredProducts.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center py-6 font-asap">
                No Orders Found
              </td>
            </tr>
          ) : (
            filteredProducts.map((item, index) => (
              <tr
                key={index}
                className="border-b border-[#AE9C91] hover:bg-gray-100 h-12"
              >
                <td className="p-4 flex flex-row items-center gap-2">
                  <div className="w-9 h-9 rounded-full bg-gray-200"></div>
                  {item.user_info?.userName}
                </td>
                <td className="p-4">#</td>
                <td className="p-4 text-center">
                  {item.product_info?.[0]?.quantity}
                </td>
                <td className="p-4 text-[#4CAF50]">
                  {item.product_info?.[0]?.price + "$"}
                </td>
                <td className="p-4 text-center">
                  <div
                    className={`h-12 rounded-2xl flex text-center items-center justify-center ${getStatusStyle(
                      item.status,
                    )}`}
                  >
                    {item.status === "Pending" && (
                      <figure className="pr-4 cursor-pointer hover:text-gray-700">
                        <LuHourglass className="text-xl text-[#937B6C]" />
                      </figure>
                    )}
                    {item.status}
                  </div>
                </td>
                <td
                  onClick={() => navigate(`/orders/detail/${item._id}`)}
                  className="p-4 text-center text-cyan-500 cursor-pointer"
                >
                  see more
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Orders;
